import Box from 'components/layouts/Box';
import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Text from 'components/commons/Text';
import { Row } from 'saladsoft-primitive';

const CheckinGuiedMenus = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const routes = [
    // { route: `/admin/checkin-guide/checkin-method`, name: '체크인 방법', children: '키패드' },
    {
      route: `/admin/checkin-guide/wifi-info`,
      name: '와이파이정보',
      children: '네트워크 ID : Butlerlee',
    },

    { route: `/admin/checkin-guide/terms-settings`, name: '약관설정' },
    {
      route: `/admin/checkin-guide/privacy-settings`,
      name: '개인정보 처리방침',
    },
    {
      route: `/admin/checkin-guide/tag-settings`,
      name: '태그',
      children: '태그 설정',
    },
  ];

  return (
    <div>
      <Row justifyContent="flex-start" padding="20px 0" gap={10}>
        <Text type="H3">공통관리</Text>
      </Row>
      <Row gap={10} flexDirection="column" width="100%">
        {routes.map((route) => (
          <div key={route.route} style={{ width: '300px' }}>
            <Box
              title={route.name}
              selected={location.pathname === route.route}
              onClick={() => navigate(route.route)}
            >
              <Text type="H5" buttonRole="DESCRIPTION">
                {route.children}
              </Text>
            </Box>
          </div>
        ))}
      </Row>
    </div>
  );
};

export default CheckinGuiedMenus;
